import React from 'react';
import styles from './Banner.module.scss';
import { getDirectusImageUrl } from '@/utils/getUrl';
import { IBannerContent } from './types';
import { Typography } from '@/components/Atoms';

type ContentProps = {
  content: IBannerContent[];
};

const BannerContent: React.FC<ContentProps> = ({ content }) => {
  return (
    <div className={styles.BannerContent}>
      {content?.map((item, index) => (
        <div
          key={index}
          className={`${styles.contentItem} ${styles[item?.image_position]}`}
          style={{
            borderColor: item?.border_color,
            backgroundImage: item?.bg_image_id ? `url(${getDirectusImageUrl(item?.bg_image_id)})` : 'none',
          }}
        >
          {item?.image_id && <img src={getDirectusImageUrl(item?.image_id)} alt={item?.title} width='85px' className={styles.image} />}
          <div className={styles.textContainer}>
            <Typography size='s12ToS12' Component={'p'} className={styles.title}>
              {item?.title}
            </Typography>
            <Typography size='s18ToS14' Component={'p'} className={styles.description}>
              {item?.description}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BannerContent;
